import cloneDeep from "lodash/cloneDeep";
import { useSelector } from "react-redux";
import {
    ReduxFirestoreQuerySetting,
    useFirestoreConnect,
} from "react-redux-firebase";
import { RootState } from "redux/model";
import { useMemo } from "react";

type UseCollectionType = ReduxFirestoreQuerySetting;

export const useCollection = <T>(
    options: UseCollectionType,
    ordered?: boolean
): T => {
    if (ordered && options.doc) {
        throw new Error(
            "You cannot use options.doc with ordered equal to true"
        );
    }
    const stateName = useMemo(() => {
        if (options.storeAs) return options.storeAs;
        if (!options.doc) return options.collection || "";

        return `${options.collection}_${options.doc}`;
    }, [options.collection, options.doc, options.storeAs]);
    useFirestoreConnect({ ...options, storeAs: stateName });

    return cloneDeep(
        useSelector((state: RootState) => {
            const result: T = ordered
                ? state.firestore["ordered"][stateName] || []
                : state.firestore["data"][stateName];

            if (options.doc) {
                return (
                    result && {
                        ...result,
                        id: options.doc,
                    }
                );
            }
            return result;
        })
    );
};
